export enum AdminRoleNames {
  SUPER_ADMINISTRATOR = 'SUPER_ADMINISTRATOR',
  PAYMENT_ADMIN = 'PAYMENT_ADMIN',
  INVESTOR_PROFILE_REVIEWER = 'INVESTOR_PROFILE_REVIEWER',
  PAYOUT_METHOD_REVIEWER = 'PAYOUT_METHOD_REVIEWER',
}
